import { Input, Modal, Typography } from 'antd';
import type { PasswordConfirmState } from '../../utils/confirmWithPassword';

/** Pairs with {@link usePasswordConfirm} — renders the actual re-entry prompt. */
export default function PasswordConfirmModal({ state }: { state: PasswordConfirmState }) {
  return (
    <Modal maskClosable={false}
      title="Confirm your password"
      open={state.open}
      onOk={state.submit}
      onCancel={state.cancel}
      confirmLoading={state.loading}
      okText="Confirm"
      destroyOnClose
    >
      <Typography.Paragraph>Re-enter your password to {state.actionLabel}.</Typography.Paragraph>
      <Input.Password
        autoFocus
        placeholder="Password"
        value={state.password}
        onChange={(e) => state.setPassword(e.target.value)}
        onPressEnter={state.submit}
      />
      {state.error && (
        <Typography.Text type="danger" style={{ display: 'block', marginTop: 8 }}>
          {state.error}
        </Typography.Text>
      )}
    </Modal>
  );
}
